import _ from 'underscore';
import PropTypes from 'prop-types';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';
import { getAudioFileUrl } from '@culture/utils/helpers/files';
import { useContext } from 'react';

import getConfig from 'next/config';

import { FilePropType } from 'propTypes/common';

import AudioPlayer from 'components/Audio/AudioPlayer';
import StyledContentImage from 'components/StyledContent/components/StyledContentImage';
// eslint-disable-next-line import/no-cycle
import StyledContentBlock from 'components/StyledContent/components/StyledContentBlock';

import { ImageFormatContext } from 'contexts/ImageFormatContext';

import { getRatioImage } from 'utils/helpers/images';

import styles from './styles.module.scss';

const { publicRuntimeConfig } = getConfig();

const CorrectAnswer = ({ isCorrect, answer }) => {
	const imageFormat = useContext(ImageFormatContext);
	const { jsonText, file, audio } = answer;
	const imageSrc =
		file &&
		getImageUrl(file, {
			format: imageFormat,
			params: {
				crop: 'fill',
				gravity: 'center'
			}
		});

	const trackUrl =
		!_.isEmpty(audio) &&
		getAudioFileUrl(audio, {
			config: publicRuntimeConfig
		});

	return (
		<div className={styles.CorrectAnswer}>
			<span className={styles.CorrectAnswer__Heading}>
				{isCorrect ? 'Правильно!' : 'Неправильно!'}
			</span>
			<div className={styles.CorrectAnswer__Main}>
				{!!trackUrl && (
					<AudioPlayer
						trackSrc={trackUrl}
						theme="light"
						className={styles.CorrectAnswer__Audio}
						autoPlay={false}
					/>
				)}
				{!!imageSrc && (
					<div className={styles.CorrectAnswer__WrapMedia}>
						<div
							className={styles.CorrectAnswer__WrapImage}
							style={{ paddingBottom: `${getRatioImage(file)}%` }}
						>
							<StyledContentImage
								src={imageSrc}
								className={styles.CorrectAnswer__Image}
								lazy={false}
							/>
						</div>
					</div>
				)}
				{!_.isEmpty(jsonText) && (
					<div className={styles.CorrectAnswer__Text}>
						{jsonText.map((block, index) => (
							<StyledContentBlock
								key={
									block?.text?.slice(0, 15) ||
									block?.src ||
									block?.url ||
									`${block?.type}-${index}`
								}
								isInteractive
								{...block}
							/>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

CorrectAnswer.propTypes = {
	isCorrect: PropTypes.bool,
	answer: PropTypes.shape({
		jsonText: PropTypes.array,
		file: FilePropType,
		audio: PropTypes.object
	})
};

export default CorrectAnswer;
